import React, { Component } from 'react'
import { Tabs, Row, Col, Form, Input, Tag, Button, Spin, Icon, Tooltip, Progress } from 'antd';
import TopNav from '../../components/topnav/topnav';
import Footer from '../../components/footer/footer';
import PostFormEdit from '../../components/postedit/postformedit'
import PostCatUpload from '../../components/postupload/postcatupload'
const TabPane = Tabs.TabPane;

class PostEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tabStyle: 'left',
      slug: ''
    };
  }

  componentWillMount() {
    const { slug } = this.props.match.params;
    this.setState({
      slug
    })
    const role = localStorage.getItem('role');
    if (role !== 'admin') {
      this.props.history.goBack();
    }
    this.switchTabStyle()
  }

  switchTabStyle = () => {
    let size = window.innerWidth
    if(size <= 415) {
      this.setState({
        tabStyle: 'top'
      })
    }
  }

  render() {
    const { tabStyle, slug } = this.state
    return (
      <div className="postedit">
        <TopNav history={this.props.history} />
        <section className="postedit-main">
        <Tabs size="large" defaultActiveKey="1" tabPosition={tabStyle}>
            <TabPane tab="Edit post" key="1">
              <Row>
                <Col lg={16} sm={24}>
                  <PostFormEdit slug={slug} history={this.props.history}/>
                </Col>
              </Row>
            </TabPane>
          </Tabs>
        </section>
        <Footer/>
      </div>
    )
  }
}

export default PostEdit